import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import axios from 'axios';
import _ from 'lodash'

@Module({namespaced: true, stateFactory: true})
export default class ConfiguratorModule extends VuexModule {
    typeId = null;
    initialPaymentPercent = 0;
    contractLengths = [24, 36, 48, 60];
    annualMileages = [10, 20, 30, 40, 50];
    contractLength = 60;
    annualMileage = 10;
    prinp2 = 1;
    prices = {};
    m = 1;
    k = 1;
    equipmentGroups = [];
    selectedEquipments = [];
    stockMode = false;
    stockSlug = '';
    currentLeadId = '';

    get getInitialPaymentPercent() {
        return this.initialPaymentPercent;
    }

    get getContractLengths() {
        return this.contractLengths;
    }

    get getAnnualMileages() {
        return this.annualMileages;
    }

    get getContractLength() {
        return this.contractLength;
    }

    get getAnnualMileage() {
        return this.annualMileage;
    }

    get getPrices() {
        return this.prices;
    }

    get getTypeId() {
        return this.typeId;
    }

    get getCalculatedPrice() {
        const partnerPrice = this.prices[`price_${this.contractLength}_${this.annualMileage}`];

        if (!partnerPrice) {
            return ''
        }

        const price = (partnerPrice * this.contractLength - (this.getInitialPaymentPercent / 100) *
            this.prinp2 * this.getM) / this.contractLength;

        return price + this.extraPriceForCalcuatedPrice;
    }

    get getInitialPayment() {
        return (this.initialPaymentPercent / 100) * (this.prinp2 + this.extraPrice);
    }

    get extras() {
        return this.getEquipments.filter(e => _.includes(this.getSelectedEquipments, e.ADDID));
    }

    get extraPrice() {
        return this.extras.reduce((sum, e) => e.ADDFlag === 1 ? sum : sum + parseFloat(e.ADDPrice2), 0);
    }

    get extraPriceForCalcuatedPrice() {
        return this.extras.reduce((sum, e) => sum += this.getEquipmentMonthlyPrice(e), 0);
    }

    get getM() {
        return this.m;
    }

    get getK() {
        return this.k;
    }

    get getEquipmentGroups() {
        return this.equipmentGroups;
    }

    get getLeftEquipmentGroups() {
        const pivot = _.ceil(this.equipmentGroups.length / 2);
        const items = _.chunk(this.equipmentGroups, pivot);

        return items[0];
    }

    get getRightEquipmentGroups() {
        const pivot = _.ceil(this.equipmentGroups.length / 2);
        const items = _.chunk(this.equipmentGroups, pivot);

        return items[1];
    }

    get getSelectedEquipments() {
        return this.selectedEquipments;
    }

    get isSelectedEquipment() {
        return (equipment) => _.includes(this.selectedEquipments, equipment.ADDID)
    }

    get getEquipments() {
        return _.flatMap(this.getEquipmentGroups, group => group.items);
    }

    get getEquipmentMonthlyPrice() {
        return (equipment) => {
            if (equipment.ADDFlag === 1) {
                return 0
            }

            return equipment.ADDPrice2 * (1 - (this.getInitialPaymentPercent / 100)) * this.getK / this.getContractLength
        }
    }

    @Mutation
    setInitialPaymentPercent(initialPaymentPercent) {
        this.initialPaymentPercent = initialPaymentPercent;
    }

    @Mutation
    setContractLengths(contractLengths) {
        this.contractLengths = contractLengths;
    }

    @Mutation
    setAnnualMileages(annualMileages) {
        this.annualMileages = annualMileages;
    }

    @Mutation
    setContractLength(contractLength) {
        this.contractLength = contractLength;
    }

    @Mutation
    setAnnualMileage(annualMileage) {
        this.annualMileage = annualMileage;
    }

    @Mutation
    setPrices(prices) {
        this.prices = prices;
    }

    @Mutation
    setPrinp2(prinp2) {
        this.prinp2 = prinp2;
    }

    @Mutation
    setM(m) {
        this.m = m;
    }

    @Mutation
    setK(k) {
        this.k = k;
    }

    @Mutation
    setTypeId(typeId) {
        this.typeId = typeId;
    }

    @Mutation
    setCurrentLeadId(currentLeadId) {
        this.currentLeadId = currentLeadId;
    }

    @Mutation
    setEquipmentGroups(groups) {
        this.equipmentGroups = groups;
    }

    @Mutation
    setSelectedEquipments(equipment) {
        this.selectedEquipments = equipment;
    }

    @Mutation
    addEquipment(equipment) {
        if (_.includes(this.selectedEquipments, equipment.ADDID)) {
            return;
        }

        this.selectedEquipments.push(equipment.ADDID);
    }

    @Mutation
    removeEquipment(equipment) {
        if (!_.includes(this.selectedEquipments, equipment.ADDID)) {
            return;
        }

        this.selectedEquipments = [..._.filter(this.selectedEquipments, e => e !== equipment.ADDID)];
    }

    @Mutation
    setStockMode(mode) {
        this.stockMode = mode;
    }

    @Mutation
    setStockSlug(slug) {
        this.stockSlug = slug;
    }


    @Action
    initialize({prices, prinp2, m, k, typeId,currentLeadId}) {
        const commit = this.context.commit;
        commit('setPrices', prices);
        commit('setPrinp2', prinp2);
        commit('setM', m);
        commit('setK', k);
        commit('setTypeId', typeId);
        commit('setCurrentLeadId', currentLeadId);

        if (prices && prices.hasOwnProperty('min_price_contract_length')) {
            commit('setContractLength', prices.min_price_contract_length);
        }

        if (prices && prices.hasOwnProperty('min_price_annual_mileages')) {
            commit('setAnnualMileage', prices.min_price_annual_mileages);
        }
    }

    @Action
    loadLead(lead) {
        const commit = this.context.commit;
        commit('setContractLength', lead.contract_length);
        commit('setAnnualMileage', lead.annual_mileage);
        commit('setInitialPaymentPercent', lead.initial_payment);
        commit('setSelectedEquipments', lead.equipmens)
    }

    @Action
    loadStock({stockEqCodes, slug}) {

        const selected = this.context.getters.getEquipments
            .filter(equipment => stockEqCodes.includes(equipment.ADDEQCode))
            .map(equipment => equipment.ADDID);


        this.context.commit('setSelectedEquipments', selected);
        this.context.commit('setStockMode', true);
        this.context.commit('setStockSlug', slug);
    }

    @Action
    loadEquipmentGroups(groups) {
        const commit = this.context.commit;

        const prepared = _.mapValues(groups, (value, index) => {
            return {
                items: [...value],
                name: index
            };
        });

        commit('setEquipmentGroups', _.values(prepared));
    }

    @Action
    saveLead(saved = false) {
        const getters = this.context.getters;

        return new Promise(resolve => {
            axios.post('/leads', {
                saved,
                type_id: this.typeId,
                initial_payment: getters.getInitialPaymentPercent,
                contract_length: getters.getContractLength,
                annual_mileage: getters.getAnnualMileage,
                equipmens: getters.getSelectedEquipments,
                stock_slug: this.stockSlug,
                current_lead_id: this.currentLeadId
            })
                .then(response => resolve(response.data))
        });
    }

    @Action
    getCustomOffer(lead_id) {
        return new Promise(resolve => {
            axios.post('/getcustomoffer', {
                lead_id: lead_id
            })
                .then(response => resolve(response.data))
        });
    }

    @Action
    setLeadSaved(lead_id) {
        return new Promise(resolve => {
            axios.post('/setleadsaved', {
                lead_id: lead_id
            })
                .then(response => resolve(response.data))
        });
    }

    @Action
    sendLead({lead_id = null, email = null}) {
        return new Promise((resolve, reject) => {
            axios.post('/leadssend', {
                lead_id: lead_id,
                email: email
            })
                .then(response => resolve(response.data))
                .catch(error => reject(error.response))

        });
    }

    @Action
    toggleEquipment(equipment) {
        const commit = this.context.commit;

        if (_.includes(this.getSelectedEquipments, equipment.ADDID)) {
            commit('removeEquipment', equipment);
            return;
        }

        commit('addEquipment', equipment);
    }
}
